import { ServiceFaq } from "@/components/shared/service-faq";
import { Typography } from "@/components/shared/typography";
import { View } from "@/components/ui";

export function ServiceFaqSection({
  faqs,
}: {
  faqs: { title: string; description: string }[];
}) {
  return (
    <View className="native:border-0 flex flex-col gap-2 border-t-4 border-secondary-border pt-4 md:border-none">
      <View className="mx-4 md:mx-0">
        <Typography className="label-xl">Frequently asked questions</Typography>
        <ServiceFaq items={faqs} />
      </View>
    </View>
  );
}
